"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const Image = createSVGIcon(
  <>
    <rect
      x="0.625"
      y="3.48214"
      width="18.75"
      height="13.9881"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M1.20001 16.9524L5.98803 8.71139C6.34432 8.09815 7.20803 8.04041 7.64278 8.60077L9.82223 11.41C10.1728 11.8618 10.8303 11.9282 11.2641 11.5554L12.4701 10.5191C12.9036 10.1466 13.5605 10.2126 13.9113 10.6638L18.8 16.9524"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M15.5 7.14286C15.5 7.63298 15.0756 8.07143 14.5 8.07143C13.9244 8.07143 13.5 7.63298 13.5 7.14286C13.5 6.65273 13.9244 6.21429 14.5 6.21429C15.0756 6.21429 15.5 6.65273 15.5 7.14286Z"
      stroke="currentColor"
    />
  </>,
  "ImageIcon",
  { viewBox: "0 0 20 20", fill: "none" }
);
